export const state = {
  
    addSignatureModal: false,

    addDocumentsModal: false,

    documentsVerifyingModal: false,

    failedVerifyModal: false, 
 
    searchRequestModal: false,
    confirmSearchRequestModal: false,
    companyToSearch: null,
    requestSentModal: false,

    errorProcessModal: false,
    errorProcessTitle: null,
    errorProcessText: null,

    successProcessModal: false,
    successProcessTitle: null,
    successProcessText: null, 


    deleteDataRequestModal: false,
    ticketId: null,
    ticketStatus: null,


    mobileInformationModal: false,

    skipMobileInfoModal: false,
}

export const getters = {
    skipMobileInfoModal: state => state.skipMobileInfoModal,

    mobileInformationModal: state => state.mobileInformationModal,

    deleteDataRequestModal: state => state.deleteDataRequestModal,
    ticketId: state => state.ticketId,
    ticketStatus: state => state.ticketStatus,
 
    addSignatureModal: state => state.addSignatureModal, 

    addDocumentsModal: state => state.addDocumentsModal, 

    documentsVerifyingModal: state => state.documentsVerifyingModal, 

    failedVerifyModal: state => state.failedVerifyModal,  

    
    searchRequestModal: state => state.searchRequestModal, 
    confirmSearchRequestModal: state => state.confirmSearchRequestModal, 
    companyToSearch: state => state.companyToSearch,
    requestSentModal: state => state.requestSentModal, 

    ///

    errorProcessModal: state => state.errorProcessModal, 
    errorProcessTitle: state => state.errorProcessTitle,
    errorProcessText: state => state.errorProcessText,
    
    ///

    successProcessModal: state => state.successProcessModal, 
    successProcessTitle: state => state.successProcessTitle,
    successProcessText: state => state.successProcessText, 
}

export const mutations = {  
    setSkipMobileInfoModal(state, value) {
        state.skipMobileInfoModal = value;
    },

    setMobileInformationModal(state, mobileInformationModal){
        state.mobileInformationModal = mobileInformationModal
    },

    setDeleteDataRequestModal(state, deleteDataRequestModal){
        state.deleteDataRequestModal = deleteDataRequestModal
    },

    setTicketId(state, ticketId){
        state.ticketId = ticketId
    },
    
    setTicketStatus(state, ticketStatus){
        state.ticketStatus = ticketStatus
    },
 
    setErrorProcessModal(state, errorProcessModal){
        state.errorProcessModal = errorProcessModal
    },

    setErrorProcessTitle(state, errorProcessTitle){
        state.errorProcessTitle = errorProcessTitle
    },

    setErrorProcessText(state, errorProcessText){
        state.errorProcessText = errorProcessText
    },

    ///

    setSuccessProcessModal(state, successProcessModal){
        state.successProcessModal = successProcessModal
    },

    setSuccessProcessTitle(state, successProcessTitle){
        state.successProcessTitle = successProcessTitle
    },

    setSuccessProcessText(state, successProcessText){
        state.successProcessText = successProcessText
    },

    ///
 
    setAddSignatureModal(state, addSignatureModal){
        state.addSignatureModal = addSignatureModal
    },

    setAddDocumentsModal(state, addDocumentsModal){
        state.addDocumentsModal = addDocumentsModal
    },
     
    setDocumentsVerifyModal(state, documentsVerifyingModal){
        state.documentsVerifyingModal = documentsVerifyingModal
    },

    setFailedVerifyModal(state, failedVerifyModal){
        state.failedVerifyModal = failedVerifyModal
    },  

    setSearchRequestModal(state, searchRequestModal){
        state.searchRequestModal = searchRequestModal
    },
    setConfrimSearchRequest(state, confirmSearchRequestModal){
        state.confirmSearchRequestModal = confirmSearchRequestModal
    }, 
    setCompanyToSearch(state, companyToSearch){
        state.companyToSearch = companyToSearch
    },
    setRequestSentModal(state, requestSentModal){
        state.requestSentModal = requestSentModal
    },
}

export const actions = {
}
 
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};